import { WidgetStoreSliceCreator } from '../types';
import { ContextEngine, CustomContext } from '@/types';

export interface ContextStore {
  context: {
    // State
    pageContext: ContextEngine.ContextResult | null;
    customContext: CustomContext;
    // Actions
    setPageContext: (pageContext: ContextEngine.ContextResult) => void;
    setCustomContext: (customContext: CustomContext) => void;
  };
}

export const createContextSlice: WidgetStoreSliceCreator<ContextStore> = (set) => ({
  context: {
    // State - customContext initialized from config (merged via initProps in store)
    pageContext: null,
    customContext: {}, // Will be overridden by initProps spread in createWidgetStore
    // Actions
    setPageContext: (pageContext: ContextEngine.ContextResult) =>
      set(state => ({ context: { ...state.context, pageContext } })),
    setCustomContext: (customContext: CustomContext) =>
      set(state => ({ context: { ...state.context, customContext } })),
  },
});
